import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#FFF"
    }, [
      _createElementVNode("path", { d: "m7.5 15.5-7 7m22-22-7 7m0 8 7 7M.5.5l7 7" }),
      _createElementVNode("path", {
        "stroke-linecap": "square",
        d: "M16.5.5h6v6m-16 16h-6v-6m0-10v-6h6m16 16v6h-6"
      })
    ], -1)
  ]))]))
}
export default { render: render }